//  @flow

import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import ChangePassword from './ChangePassword';

// Actions
import { changePassword } from 'store/reducers/user/personInfo/actions';

export default compose(
  injectIntl,
  connect(
    null,
    {
      changePassword
    }
  )
)(ChangePassword);



// WEBPACK FOOTER //
// ./src/components/pages/User/Profile/components/ChangePassword/ChangePasswordContainer.js